import { useInfiniteQuery } from '@tanstack/react-query';

// types
import {
	SearchUserClaimsRequest,
	SearchUserClaimsResponse,
	ClaimSort,
	FullTextSearchClaim,
	INVITED_USER_POSSIBLE_SEARCH,
	INVITATION_ACCEPTED_STATUS,
} from '@joc/api-gateway/lib/api-client';

// core
import { API } from 'core/API';
import { PENDING_VOLUNTEERS_QUERY_KEY } from 'core/constants';

const fetchPendingVolunteers = async ({
	skip,
	take,
	sort,
	search,
}: {
	skip: number;
	take: number;
	search?: string;
	sort?: ClaimSort;
}): Promise<SearchUserClaimsResponse> =>
	API.adminSearchClaims(
		SearchUserClaimsRequest.fromJS({
			pagination: {
				skip,
				take,
			},
			isAccepted: [INVITATION_ACCEPTED_STATUS.NotAccepted],
			...(search
				? {
						fullTextSearch: FullTextSearchClaim.fromJS({
							fields: [
								INVITED_USER_POSSIBLE_SEARCH.FirstName,
								INVITED_USER_POSSIBLE_SEARCH.LastName,
								INVITED_USER_POSSIBLE_SEARCH.Email,
								INVITED_USER_POSSIBLE_SEARCH.PhoneNumber,
								INVITED_USER_POSSIBLE_SEARCH.OrgName,
							],
							value: search,
						}),
				  }
				: {}),
			sort,
		})
	);

export const usePendingVolunteers = (search: string, sort?: ClaimSort, externalTake = 10) =>
	useInfiniteQuery<SearchUserClaimsResponse, unknown>({
		queryKey: [PENDING_VOLUNTEERS_QUERY_KEY, { search, sort, externalTake }],
		initialPageParam: 0,
		queryFn: ({ pageParam = 0 }) =>
			fetchPendingVolunteers({ skip: pageParam as number, take: externalTake, search, sort }),
		getNextPageParam: (lastPage, allPages) => {
			return lastPage.records.length < externalTake ? undefined : allPages.length * externalTake;
		},
	});
